import { MouseEventHandler, ReactNode } from "react"
import style from "./TableListButton.module.scss"

interface Props {
  children: ReactNode
  disabled?: boolean
  title: string
  onClick: MouseEventHandler
  large?: boolean
}

export function TableListButton({
  children,
  disabled,
  title,
  onClick,
  large,
}: Props) {
  return <button
    className={`${style.button} ${large ? style.large : ""}`}
    onClick={event => {
      onClick(event)
      event.preventDefault()
    }}
    disabled={disabled}
    title={title}
  >
    {children}
  </button>
}